import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { clearToken } from "../services/auth";

const Header: React.FC = () => {
  const location = useLocation();

  const handleLogout = () => {
    clearToken();
    window.location.reload();
  };

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <Navbar expand="lg" className="gogi-navbar mb-0">
      <Container fluid className="px-4">
        <Navbar.Brand as={Link} to="/">
          Gogi ML System
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="gogi-navbar" />
        <Navbar.Collapse id="gogi-navbar">
          <Nav className="me-auto ms-2">
            <Nav.Link as={Link} to="/" active={isActive("/") && location.pathname === "/"}>
              Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to="/live-trading" active={isActive("/live-trading")}>
              Live Trading
            </Nav.Link>
            <Nav.Link as={Link} to="/algos" active={isActive("/algos")}>
              Saved Algos
            </Nav.Link>
            <Nav.Link as={Link} to="/algo-studio" active={isActive("/algo-studio")}>
              Algo Studio
            </Nav.Link>
            <Nav.Link as={Link} to="/api-keys" active={isActive("/api-keys")}>
              API Keys
            </Nav.Link>
          </Nav>
          <Button variant="outline-light" size="sm" onClick={handleLogout}>
            Sign out
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
